import { create } from './Create/Create.i18n.ja'
import { imports } from './Import/Import.i18n.ja'
import { list } from './List/List.i18n.ja'

export const idCards = {
  list,
  create,
  imports,
}
